import {
  Ref, computed,
} from 'vue'
import type {
  Options as PopperOptions,
} from '@popperjs/core'
import usePopper from './usePopper'
import usePopover, {
  PopoverOption, watchGlobalClick,
} from './usePopover'

type SelectOption = {
  disabled: boolean | Ref<boolean>
}

type SelectPopover = PopoverOption & SelectOption & PopperOptions
export type SelectPopoverPartial = {
  [P in keyof SelectPopover]?: SelectPopover[P]
} & {
  sameWidth?: boolean
}

interface SelectPopoverHooks {
  targetRef: Ref<HTMLElement|null>
  popperRef: Ref<HTMLElement|null>
  toggle: (flag?: boolean) => void
  isActive: Ref<boolean>
  update: () => void
}

export const useSelectPopover = (
  options: SelectPopoverPartial,
): SelectPopoverHooks => {
  const {
    disabled, ...popperOptions
  } = options

  const {
    isShownState,
    toggle,
  } = usePopover({
    trigger: 'manual',
  })
  const isShowSelect = computed(() => {
    const isDisabled = typeof disabled === 'boolean'
      ? disabled
      : disabled?.value
    if (isDisabled) {
      return false
    }
    return isShownState.value
  })

  const { targetRef, popperRef, update } = usePopper(
    isShowSelect,
    {
      sameWidth: true,
      ...popperOptions,
    },
  )

  watchGlobalClick({
    targetRef,
    popperRef,
    toggle,
    isShownState,
  })

  return {
    targetRef,
    popperRef,
    update,
    toggle,
    isActive: isShowSelect,
  }
}

export { default as usePopper } from './usePopper'
export { default as usePopover } from './usePopover'
export * from './usePopover'
